module.exports = __webpack_public_path__ + "static/media/Slice12@2x.ad887e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice12@2x.png
// module id = 1440
// module chunks = 0